/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardActions,
  CardContent,
  Container,
  Typography,
  Fade,
  IconButton,
  Collapse,
  Link,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/system';
import { FaCalendar } from 'react-icons/fa';
// Wimss context
import {
  useWimssController,
  setIsMobile,
  setCurrentPage,
  setCurrentTexts,
} from 'context';
import HoverImage from 'react-hover-image';
import { initTexts } from 'utils/syncState';
import YoutubeEmbed from 'assets/videos/YoutubeEmbed';

//import hero pictures and background images
import SandyBeach from 'assets/images/pictures/sandy-beach.png';
import BlueSky from 'assets/images/pictures/bluesky.png';
import NewBanner from 'assets/images/pictures/news-banner.png';
import Boardroom from 'assets/images/pictures/boardroom.png';
import BoardroomHover from 'assets/images/pictures/boardroom-hover.png';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ expand }) => !expand,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ expand }) => !!expand,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));

const NewsHero = () => {
  return (
    <Box
      sx={{
        backgroundImage: `url(${NewBanner})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto',
        overflow: 'hidden',
        overflowY: 'auto',
        width: '100vw',
        height: '100%',
        position: 'relative',
      }}>
      <Fade
        in={true}
        style={{
          transitionDelay: 500,
        }}>
        <img
          src={NewBanner}
          alt={'Latest News'}
          style={{
            width: '100%',
            height: 'auto',
            objectFit: 'cover',
          }}
        />
      </Fade>
    </Box>
  );
};

const StyledCard = styled(Card)(({ theme }) => ({
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[8],
  },
  marginBottom: theme.spacing(3),
}));

const News = () => {
  const [controller, dispatch] = useWimssController();
  const { currentLanguage, isMobile, currentPage, currentTexts } = controller;
  const [expanded, setExpanded] = useState([]);

  const Page = 'news';
  const { innerWidth: width } = window;
  const navigate = useNavigate();
  const [refreshActBtn, setRefreshActBtn] = useState(true);

  useEffect(() => {
    if (width <= 600) {
      setIsMobile(dispatch, true);
    } else setIsMobile(dispatch, false);
    setCurrentPage(dispatch, Page);
  }, []);

  useEffect(() => {
    // initHero(isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (currentLanguage !== '') {
      setRefreshActBtn(false);
    }

    //set pageTexts
    let pageTxts = initTexts(currentLanguage, currentPage);
    setCurrentTexts(dispatch, pageTxts);
  }, [currentLanguage, currentPage]);

  useEffect(() => {
    if (currentTexts !== null && !refreshActBtn) {
      if (expanded.length === 0 && currentTexts[0].paragraphs.length > 0) {
        let expArr = [];
        for (let i = 0; i < currentTexts[0].paragraphs.length; i++)
          expArr.push(false);
        setExpanded(expArr);
      }
      setRefreshActBtn(true);
    }
  }, [currentTexts]);

  useEffect(() => {
    console.log(expanded);
  }, [expanded]);

  const handleExpandClick = (id) => {
    const expArr = [...expanded];
    for (let i = 0; i < expArr.length; i++) {
      if (id === i) expArr[i] = !expArr[i];
    }
    setExpanded(expArr);
  };
  return (
    <Box sx={{ flexGrow: 1, mt: 0 }}>
      {currentTexts !== null && (
        <Grid
          container
          // columns={{ xs: 4, sm: 8, md: 12 }}
          direction='column'
          spacing={{ xs: 0, md: 0 }}>
          <Grid size={12}>
            <NewsHero />
          </Grid>
        </Grid>
      )}

      {currentTexts !== null &&
        currentTexts[0].paragraphs.length > 0 &&
        refreshActBtn && (
          <Box
            sx={{
              backgroundImage: `url(${BlueSky})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'repeat-Y',
              overflowY: 'auto',
              width: '100vw',
              height: '100%',
              top: 0,
              left: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              textAlign: 'left',
              mt: -1,
            }}>
            <Container sx={{ mt: isMobile ? 2 : 0 }} maxWidth='lg'>
              <Grid container spacing={{ xs: 0, md: 4 }}>
                {currentTexts[0].paragraphs.map((post) => (
                  <Grid item xs={12} key={post.id}>
                    <StyledCard>
                      <CardContent>
                        <Typography variant='h5' component='h2' gutterBottom>
                          {post.title}
                        </Typography>
                        <Typography
                          variant='subtitle2'
                          color='text.secondary'
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            mb: 2,
                          }}>
                          <FaCalendar />
                          {post.subtitle}
                        </Typography>
                        {/* <Typography variant='body' color='text.secondary'>
                          {post.content}
                        </Typography> */}
                      </CardContent>
                      <CardActions disableSpacing>
                        <ExpandMore
                          expand={expanded[post.id]}
                          onClick={() => handleExpandClick(post.id)}
                          aria-expanded={expanded[post.id]}
                          aria-label='show more'>
                          <ExpandMoreIcon />
                        </ExpandMore>
                      </CardActions>
                      <Collapse
                        in={expanded[post.id]}
                        timeout='auto'
                        unmountOnExit>
                        <CardContent>
                          <Typography variant='h5' color='text.secondary'>
                            {post.content}
                          </Typography>
                        </CardContent>
                      </Collapse>
                    </StyledCard>
                  </Grid>
                ))}
              </Grid>
            </Container>
            
        <Box
          sx={{
            width: isMobile ? 350 : 800,

            height: 'auto',
            mt: 8,
          }}>
          <YoutubeEmbed
            embedId='lAIiHco4KqI?si=YKxng9lhxsHYpcss'
            width={isMobile ? 350 : 800}
            height={isMobile ? 197 : 450}
            videoTitle='WIMSS 2025 AGM'
          />
        </Box>

            <Box
              sx={{
                backgroundImage: `url(${SandyBeach})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'repeat-Y',
                overflowY: 'auto',
                width: '100vw',
                height: 400,

                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
              }}>
              <HoverImage
                src={Boardroom}
                hoverSrc={BoardroomHover}
                onClick={() => navigate('/boardroom')}
                style={{ height: '174px' }}
              />
              <Link
                href='https://meet.google.com/bat-qeku-aev'
                underline='hover'>
                Join Meeting
              </Link>
            </Box>
          </Box>
        )}
    </Box>
  );
};

export default News;
